import { useState, useEffect } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { bypassTask, updateTaskNoValidation } from '../../../../../../helpers/apiCalls';
import useTemplateState from '../../../../../../../Template/atoms/variables';
import { useMsal } from '@azure/msal-react';

import './style.css';

const BypassButton = ({ systemTask, title, bypassCallback = null }) => {
  const { t } = useTranslation();
  const { instance } = useMsal();
  const {
    setPendingApiCalls,
    setModalContent,
    setModalTitle,
    setModalStyle,
    setModalConfirm,
    setCleanOnCancel,
    setModalOpen,
  } = useTemplateState();

  const [task, setTask] = useState(systemTask);
  const [input, setInput] = useState('');

  useEffect(() => {
    setTask(systemTask);
  }, [systemTask]);

  useEffect(() => {
    setModalContent(
      <ModalBody
        handleTextAreaChange={handleTextAreaChange}
        handleBypass={handleBypass}
        input={input}
        t={t}
      />,
    );
  }, [input]);

  const openModal = () => {
    setModalTitle(`${t('bypass')} (${title})`);
    setModalContent(
      <ModalBody
        handleTextAreaChange={handleTextAreaChange}
        handleBypass={handleBypass}
        input={input}
        t={t}
      />,
    );
    setModalStyle({
      padding: '2rem',
      gap: '1rem',
      minHeight: '50%',
      minWidth: '55%',
      flexGrowth: 1,
    });
    setModalConfirm(null);
    setCleanOnCancel(true);
    setModalOpen(true);
  };

  const handleTextAreaChange = (e) => {
    setInput(e.target.value);
  };

  const handleBypass = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['bypassTask']));
      await bypassTask(instance, {
        taskId: task._id,
        reason: input,
      });

      if (bypassCallback) {
        bypassCallback();
      }

      setModalOpen(false);
    } catch (err) {
      console.log(err);
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'bypassTask'));
    }
  };

  return (
    <div>
      <Button
        className='bypass-button'
        size='large'
        style={{
          backgroundColor: 'white',
          border: '1px solid #333333',
          color: '#333333',
          opacity:
            !task ||
            task?.bypass?.bypassed ||
            task?.status?.toLowerCase() === 'validated' ||
            task?.status?.toLowerCase() === 'fail'
              ? 0.5
              : 1,
        }}
        disabled={
          !task ||
          task?.bypass?.bypassed ||
          task?.status?.toLowerCase() === 'validated' ||
          task?.status?.toLowerCase() === 'fail'
        }
        onClick={() => openModal()}
      >
        {t('bypass')}
      </Button>
    </div>
  );
};

const ModalBody = ({ handleTextAreaChange, handleBypass, input, t }) => {
  return (
    <div className='bypassModalContent' key={`bypassModalContent`}>
      <div className='bypassDescription'>{t('bypass_description')}</div>
      <textarea
        className='bypassTextArea'
        placeholder={t('bypass_placeholder')}
        onChange={handleTextAreaChange}
        value={input}
      />
      <Button
        className='bypassButton'
        disabled={input.trim().length === 0}
        size='large'
        style={{
          backgroundColor: '#1777FF',
          border: '#1777FF',
          color: 'white',
          opacity: input.trim().length > 0 ? 1 : 0.5,
          marginLeft: 'auto',
        }}
        onClick={handleBypass}
      >
        {t('bypass')}
      </Button>
    </div>
  );
};

export default BypassButton;
